import { FC, memo, useCallback } from "react";

import { useAppDispatch } from "@/hooks/redux";
import { ProductCardWithCounterUI } from "@/pages/WorkPlan/Tasks/components/ProductCardWithCounterUI";
import { setRejectedProduct } from "@/store/slices/progress";

interface RejectProductCardProps {
    barcode: string;
    name: string;
    itemsLeft: number;
    taskId: string;
    rejectProductsCounter?: number;
    price: number;
    isLast: boolean;
    onView: () => void;
}

export const RejectProductCard: FC<RejectProductCardProps> = memo(
    ({
        barcode,
        name,
        onView,
        isLast,
        price,
        taskId,
        rejectProductsCounter,
        itemsLeft,
    }) => {
        const dispatch = useAppDispatch();

        const handleAddReject = useCallback(() => {
            dispatch(
                setRejectedProduct({
                    taskId,
                    product: {
                        barcode,
                        name,
                        count: 1,
                        price,
                    },
                }),
            );
        }, [dispatch, barcode, name, price, taskId]);

        const handleRejectCountChange = useCallback(
            (count: number) => {
                dispatch(
                    setRejectedProduct({
                        taskId,
                        product: {
                            barcode,
                            name,
                            count,
                            price,
                        },
                    }),
                );
            },
            [dispatch, taskId, barcode, name, price],
        );

        const isAddMode = !(
            typeof rejectProductsCounter === "number" &&
            rejectProductsCounter > 0
        );

        return (
            <ProductCardWithCounterUI
                name={name}
                barcode={barcode}
                isLast={isLast}
                onView={onView}
                counterMax={itemsLeft}
                remaining={itemsLeft}
                remainingTitle="Залишки в магазині:"
                {...(isAddMode
                    ? {
                          counterType: "add" as const,
                          onAddTouchStart: handleAddReject,
                      }
                    : {
                          counterType: "counter" as const,
                          counterValue: rejectProductsCounter as number,
                          onCounterChange: handleRejectCountChange,
                      })}
            />
        );
    },
);

RejectProductCard.displayName = "RejectProductCard";
